import { render, staticRenderFns } from "./ThePageNotFoundLayout.vue?vue&type=template&id=f8f0d178&scoped=true&"
import script from "./ThePageNotFoundLayout.vue?vue&type=script&lang=js&"
export * from "./ThePageNotFoundLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f0d178",
  null
  
)

export default component.exports